import SavedPosts from "./SavedPosts";
export default SavedPosts;
